import { render, staticRenderFns } from "./MekariSidebar.vue?vue&type=template&id=4a145628&scoped=true&"
import script from "./MekariSidebar.vue?vue&type=script&lang=js&"
export * from "./MekariSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MekariSidebar.vue?vue&type=style&index=0&id=4a145628&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a145628",
  null
  
)

export default component.exports